import { __assign } from "tslib";
import * as React from 'react';
function getSpan(row, index, cols) {
    var l = row.cells.length;
    if (l !== cols) {
        var _a = row.spans, spans = _a === void 0 ? [] : _a;
        if (spans.length > index) {
            var span = row.spans[index];
            return "span ".concat(span);
        }
        else if (l === 1) {
            return "span ".concat(cols);
        }
        else if (l === index + 1) {
            var obtained = spans.reduce(function (sum, v) { return sum + v; }, 0);
            var span = spans.length + 1 + cols - l - obtained;
            return "span ".concat(span);
        }
    }
    return undefined;
}
function getBoundingClientRectOfContents() {
    var isContents = window.getComputedStyle(this).display === 'contents';
    if (isContents) {
        // Usually, this will only yield 0s; so we need to make sure that it returns
        // the dimensions of its contained content.
        var el = this;
        var rects = Array.from(el.children).map(function (m) { return m.getBoundingClientRect(); });
        var first = rects[0];
        var last = rects[rects.length - 1];
        var coords_1 = {
            bottom: first.bottom,
            height: first.height,
            left: first.left,
            right: last.right,
            top: first.top,
            width: rects.reduce(function (sum, m) { return sum + m.width; }, 0),
            x: first.x,
            y: first.y,
        };
        return __assign(__assign({}, coords_1), { toJSON: function () {
                return JSON.stringify(coords_1);
            } });
    }
    return HTMLElement.prototype.getBoundingClientRect.call(this);
}
function modifyRow(el) {
    if (el) {
        // changes computation to allow dragging
        el.getBoundingClientRect = getBoundingClientRectOfContents;
    }
}
function getTitle(node) {
    if (typeof node === 'string') {
        return node;
    }
    else if (React.isValidElement(node)) {
        var children = node.props.children || [];
        if (Array.isArray(children)) {
            var child = children.find(function (m) { return typeof m === 'string'; });
            if (child) {
                return child;
            }
        }
    }
    return '';
}
export var Table = React.forwardRef(function (_a, ref) {
    var headers = _a.headers, rows = _a.rows;
    var gridTemplateColumns = headers.map(function (m) { return m.width || '1fr'; }).join(' ');
    return (React.createElement("div", { className: "table-container" },
        React.createElement("div", { className: "table", style: { gridTemplateColumns: gridTemplateColumns } },
            React.createElement("div", { className: "row header" }, headers.map(function (header, headerIndex) { return (React.createElement("div", { className: "cell", key: header.id, style: { width: header.width } }, header.cell)); })),
            React.createElement("div", { className: "table-rows", ref: ref }, rows.map(function (row) { return (React.createElement("div", { className: row.hidden ? 'row row-hidden' : 'row row-visible', style: { gridTemplateColumns: gridTemplateColumns }, "data-id": row.id, key: row.id, ref: modifyRow }, row.cells.map(function (cell, index) {
                var header = headers[index];
                var gridColumn = getSpan(row, index, headers.length);
                var title = gridColumn ? '' : getTitle(header.cell);
                return (React.createElement("div", { className: "cell", "data-title": title, key: header.id, style: { gridColumn: gridColumn } }, cell));
            }))); })))));
});
//# sourceMappingURL=index.js.map